// PAGINATION
const PAGE_SIZE = 100

// SAVE AND RESTORE SESSION
const SAVE_TO_SESSION_STORAGE = (data, key) => {
  if (key) {
    sessionStorage.setItem(key, JSON.stringify(data))
  }
}

const RESTORE_FROM_SESSION_STORAGE = (key) => {
  try {
    if (key) {
      const data = sessionStorage.getItem(key)
      if (data) {
        return JSON.parse(data)
      }
    }
    return []
  } catch {
    return []
  }
}

// MIXIN
export default {
  data () {
    return {
      // FETCH
      items: [],
      countAll: null,
      loading: false,
      fetching: false,
      fetchCallback: null,

      // PAGINATION
      page: 1,
      pageCount: 1,

      // QUERY PARAMS
      params: {},

      // CACHE
      cacheKey: null
    }
  },

  computed: {
    showPagination () {
      return this.pageCount > 1 && !this.loading
    }
  },

  watch: {
    page () {
      const query = {
        ...this.params,
        page: this.page
      }
      const { path, params } = this.$route
      this.$router.push({ path, params, query })
    },

    '$route.query': {
      handler () {
        const { page, ...params } = this.$route.query
        this.page = page ? parseInt(page) : 1
        this.params = params
        if (!this.fetching) {
          this.loadData()
        }
      },
      deep: true
    },

    params: {
      handler () {
        const query = {
          ...this.params,
          page: this.page
        }
        const { path, params } = this.$route
        this.$router.push({ path, params, query })
      },
      deep: true
    }
  },

  mounted () {
    const { page, ...params } = this.$route.query
    this.page = page ? parseInt(page) : 1
    this.params = params
  },

  methods: {
    async pageChangeHandler (page) {
      this.loading = true
      this.page = page
      await this.loadData()
    },

    async setupPagination (fetchCallback = null, params = {}, cacheKey = null) {
      if (fetchCallback) {
        this.fetchCallback = fetchCallback
        this.params = {
          ...this.params,
          ...params
        }
        this.cacheKey = cacheKey
        this.loadData()
      }
    },

    async loadData (params = {}) {
      this.fetching = true
      this.loading = true
      if (!this.items.length) {
        const cachedItems = RESTORE_FROM_SESSION_STORAGE(this.cacheKey)
        this.items = cachedItems.length
          ? cachedItems
          : []
        this.loading = this.items.length === 0
      } else {
        this.loading = true
      }
      this.params = {
        ...this.params,
        ...params
      }
      const queryParams = {
        ...this.params,
        offset: (this.page - 1) * PAGE_SIZE || null
      }
      const { data, count } = await this.fetchCallback(queryParams)
      this.items = data
      this.countAll = count
      SAVE_TO_SESSION_STORAGE(data, this.cacheKey)
      this.pageCount = Math.floor(count / PAGE_SIZE) + (count % PAGE_SIZE > 0 ? 1 : 0)
      this.loading = false
      this.fetching = false
    }
  }
}
